function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebookLogo = function SvgFacebookLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M24 12.07c0-6.63-5.37-12-12-12S0 5.45 0 12.08c0 5.9 4.29 10.93 10.12 11.85v-8.39H7.07v-3.47h3.05V9.43c0-3.01 1.79-4.67 4.53-4.67.9.01 1.8.09 2.69.23v2.95h-1.51c-.95-.13-1.82.54-1.95 1.49q-.03.195 0 .39v2.25h3.33l-.53 3.47h-2.8v8.39c5.83-.92 10.13-5.95 10.13-11.85Z",
    style: {
      fill: "currentColor",
      strokeWidth: 0
    }
  }));
};
export default SvgFacebookLogo;